import { Component } from '@angular/core';
import { take } from 'rxjs/operators';

import { CHECKOUT_STEP, CheckoutFlowService } from '../../../../../../checkout/checkout-flow.service';
import { CheckoutService } from '../../../../../../checkout/checkout.service';

@Component({
    selector: 'app-payment-summary',
    template: `
        <ng-container *ngIf="checkoutService.getCheckoutData() | async as cd">
            <section
                class="summary"
                [ngClass]="{
                    'summary--active': true,
                    'summary--has-error': hasValidationError,
                    'loan--loading': !!(checkoutService.aftermarketEquipmentLoanLoading$ | async)
                }"
                appCircleCheckmark
                [condition]="!hasValidationError"
                appCircleError
                [errorCondition]="hasValidationError"
            >
                <div class="summary__header">
                    <h3 class="h5 no-margin">
                        {{ 'checkout.summary_step____payment_section____headline' | translate }}
                    </h3>
                    <app-button
                        (click)="checkoutflowService.goToStep(step)"
                        [buttonClass]="'button--minimal theme-text'"
                        [title]="(hasValidationError ? 'checkout.summary_step____button_currect_step' : 'buttons.edit') | translate"
                    >
                    </app-button>
                </div>
                <div class="summary__content text-small">
                    <div class="unstyled-table unstyled-table--first-child-bold" role="table">
                        <div class="unstyled-table__row" role="row">
                            <div class="unstyled-table__cell" role="cell">
                                {{ 'checkout.summary_step____payment_section____selected_method' | translate }}
                            </div>
                            <div class="unstyled-table__cell" role="cell">
                                <ng-container *ngIf="cd.cash">
                                    {{ 'checkout.summary_step____payment_section____selected_method____cash' | translate }}
                                </ng-container>
                                <ng-container *ngIf="cd.loan">
                                    {{ 'checkout.summary_step____payment_section____selected_method____loan' | translate }}
                                </ng-container>
                            </div>
                        </div>
                        <ng-container *ngIf="cd.cash">
                            <div class="unstyled-table__row" role="row">
                                <div class="unstyled-table__cell" role="cell">
                                    {{ 'checkout.summary_step____payment_section____cash_price' | translate }}
                                </div>

                                <ng-container
                                    *ngIf="checkoutService.aftermarketEquipmentData$ | async as amed; else grossPrice"
                                    class="unstyled-table__row"
                                    role="row"
                                >
                                    <div *ngIf="cd.offer?.closedOnExchangePrice; else price" class="unstyled-table__cell" role="cell">
                                        {{ cd.offer?.exchangePrice | defaultcurrency }}
                                    </div>
                                    <ng-template #price>
                                        <div class="unstyled-table__cell" role="cell">
                                            <span class="loan__detail-value-wrapper">
                                                <span class="loan__detail-value">
                                                    <ng-container *ngIf="amed.carTotalPrice !== undefined">
                                                        {{ amed.carTotalPrice | defaultcurrency }}
                                                        carTotalPricecarTotalPricecarTotalPricecarTotalPrice
                                                    </ng-container>
                                                </span>
                                            </span>
                                        </div>
                                    </ng-template>
                                </ng-container>
                                <ng-template #grossPrice>
                                    <div class="unstyled-table__cell" role="cell">
                                        {{ cd.product?.grossPrice | defaultcurrency }}
                                    </div>
                                </ng-template>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="cd.loan">
                            <div class="unstyled-table__row" role="row">
                                <div class="unstyled-table__cell" role="cell">
                                    {{ 'loan.down_payment' | translate }}
                                </div>
                                <div class="unstyled-table__cell" role="cell">
                                    <span class="loan__detail-value-wrapper">
                                        <span class="loan__detail-value">{{ cd.loan?.downPayment | defaultcurrency }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="unstyled-table__row" role="row">
                                <div class="unstyled-table__cell" role="cell">
                                    {{ 'loan.payment_per_month' | translate }}
                                </div>
                                <div class="unstyled-table__cell" role="cell">
                                    <span class="loan__detail-value-wrapper">
                                        <span class="loan__detail-value">{{ cd.loan?.paymentPerMonth | defaultcurrency }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="unstyled-table__row" role="row">
                                <div class="unstyled-table__cell" role="cell">
                                    {{ 'loan.monthly_terms' | translate }}
                                </div>
                                <div class="unstyled-table__cell" role="cell">
                                    <span class="loan__detail-value-wrapper">
                                        <span class="loan__detail-value">{{
                                            'loan.monthly_terms_months' | translate: { months: cd.loan?.paymentTerms }
                                        }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="unstyled-table__row" role="row">
                                <div class="unstyled-table__cell" role="cell">
                                    {{ 'loan.aop_before_tax' | translate }}
                                </div>
                                <div class="unstyled-table__cell" role="cell">
                                    <span class="loan__detail-value-wrapper">
                                        <span class="loan__detail-value">{{ cd.loan?.aopBeforeTax }}{{ cd.loan?.aopBeforeTax && '%' }}</span>
                                    </span>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </section>
        </ng-container>
    `,
})
export class PaymentSummaryComponent {
    step = CHECKOUT_STEP.CS_PAYMENT;
    hasValidationError?: boolean;
    constructor(public checkoutService: CheckoutService, public checkoutflowService: CheckoutFlowService) {
        this.checkoutService.purchaseOrderValidation$.pipe(take(2)).subscribe((data) => {
            if (data) {
                this.hasValidationError = !!data?.errors?.find(
                    (e) => e.property?.split('.')?.[0] === 'Cash' || e.property?.split('.')?.[0] === 'Loan'
                ); // Maybe - property names are strings, no modelled by BE.
            }
        });
    }
}
